import { AWXActivityEventType, AWXCardActivityEventStatus } from '@ankor-io/common/types/transaction/transaction'

export const getPaymentStatusIcon = (transactionAwxActivityEventType: AWXActivityEventType) => {
  switch (transactionAwxActivityEventType) {
    case AWXActivityEventType.CARD_TRANSACTION:
      return '💳'
    case AWXActivityEventType.DEPOSIT:
      return '💰'
    case AWXActivityEventType.TRANSFER:
      return '💸'
  }
}

export const getPaymentStatusColour = (awxActivityEventStatus: AWXCardActivityEventStatus) => {
  const GREEN_COLOUR = '#22c55e'
  const RED_COLOUR = '#ef4444'
  switch (awxActivityEventStatus) {
    case AWXCardActivityEventStatus.SUCCEEDED:
      return GREEN_COLOUR
    case AWXCardActivityEventStatus.FAILED:
      return RED_COLOUR
  }
}

export const getPaymentStatusText = (awxActivityEventStatus: AWXCardActivityEventStatus) => {
  switch (awxActivityEventStatus) {
    case AWXCardActivityEventStatus.SUCCEEDED:
      return 'Success'
    case AWXCardActivityEventStatus.FAILED:
      return 'Failed'
  }
}
